module.exports = __webpack_public_path__ + "img/topsmjt_bg.5abcdbd0.png";